import { FC } from 'react';
import './shopReviewCarousel.scss';
import { FilledStar } from 'tedooo-web-design-system/icons';

import { EmptyStateOptions, IReviewRow } from 'types';
import { MultiItemsCarousel } from 'components/carousels';
import { ShopReviewCarouselSettings } from './ShopReviewCarouselSettings';
import ReviewRow from 'pages/shopPage/content/reviews/reviewRow/ReviewRow';
import { isEmptyArray } from 'utils';
import { EmptyState } from 'components/emptyState';

const ShopReviewsCarousel: FC<{ totalReviews: number; average: number; reviews: IReviewRow[] }> = ({
  average,
  reviews,
  totalReviews,
}) => {
  const renderContent = () => {
    if (isEmptyArray(reviews)) {
      return <EmptyState type={EmptyStateOptions.ShopReviews} />;
    }

    return (
      <>
        <span className="title">
          Shop reviews ({totalReviews}) · <FilledStar />{' '}
          <span className="average-reviews">
            {average.toFixed(1)}
            <span className="light-text">/5</span>
          </span>
        </span>
        <MultiItemsCarousel settings={ShopReviewCarouselSettings} responsiveArrows={false}>
          {reviews.map((review) => (
            <ReviewRow
              key={review.id}
              name={review.name}
              value={review.value}
              avatar={review.avatar}
              title={review.title}
              id={review.id}
              text={review.text}
              date={review.date}
              images={review.images}
            />
          ))}
        </MultiItemsCarousel>
      </>
    );
  };

  return <div className="reviews-carousel-container">{renderContent()}</div>;
};

export default ShopReviewsCarousel;
